import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { getAllUserPreference } from '../../../redux/slices';
import './TimeZone.css'
const TimeZone = () => {
  const dispatch = useDispatch()
  const t = useAppSelector((state) => state.userPreference.data.timezone)
  const userTime = t?.val;

  useEffect(() => {
    dispatch(getAllUserPreference)
  },[])

  return (
    <p className='navbar-text navbar-right'>
      <a href='/ui/#!/account'>{userTime}</a>
    </p>
  )
}

export default TimeZone
